import * as React from 'react';
export const IcBluetoothConnected = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.92 16.15v-.12a1.099 1.099 0 00-.28-.33L13.67 12l4.93-3.7a1.1 1.1 0 00.28-.3v-.12a1.37 1.37 0 00.12-.32V7.5v-.09a1.307 1.307 0 00-.06-.27 1.088 1.088 0 00-.1-.14.357.357 0 000-.09 1.273 1.273 0 00-.13-.11s0-.07-.07-.09l-6-4.5A1 1 0 0011 3v7L6.6 6.7a1 1 0 00-1.2 1.6l4.93 3.7-4.93 3.7a1 1 0 101.2 1.6L11 14v7a1 1 0 00.55.89 1.001 1.001 0 001-.09l6-4.5s.06-.08.09-.11.08-.05.11-.09a.357.357 0 000-.09c.03-.048.057-.098.08-.15.03-.088.05-.178.06-.27v-.09-.06c.02-.096.03-.193.03-.29zM13 5l3.33 2.5L13 10V5zm0 14v-5l3.33 2.5L13 19zm6.5-8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM6 12a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z'
      fill='currentColor'
    />
  </svg>
);
